const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

// The function to be executed when a dynamically added element is clicked
function handleElementClick(event) {
  const yotpoMainWidget = document.getElementById('yotpo-reviews-main-widget');
  yotpoMainWidget.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  });
}

// The callback function for the MutationObserver
const observerCallback = (mutationsList, observer) => {
    // Look through all mutations that just occurred
    for (const mutation of mutationsList) {
        // Check if the change was adding child nodes
        if (mutation.type === 'childList') {
            // Iterate over all added nodes
            for (const node of mutation.addedNodes) {
                // Check if the added node is an actual element and matches your criteria (e.g., has a specific class)
                if (node.nodeType === Node.ELEMENT_NODE && node.matches('.yotpo-widget-instance button.yotpo-sr-bottom-line-summary')) {
                    // Attach the click event listener
                    node.addEventListener('click', handleElementClick);
                }
                // If new elements are inside a subtree, search within them as well
                if (node.querySelector && node.querySelector('.yotpo-widget-instance button.yotpo-sr-bottom-line-summary')) {
                    const nestedElements = node.querySelectorAll('.yotpo-widget-instance button.yotpo-sr-bottom-line-summary');
                    nestedElements.forEach(nestedEl => {
                        nestedEl.addEventListener('click', handleElementClick);
                    });
                }
            }
        }
    }
};

// Create a new instance of MutationObserver with the callback function
const observer = new MutationObserver(observerCallback);

// Configuration of the observer:
// Watch for additions/removals of child nodes (childList: true)
// and also observe the entire subtree (subtree: true)
const observerConfig = {
    childList: true,
    subtree: true
};

// Start observing the target node (e.g., the body, or a specific container)
// for the configured mutations
const targetNode = document.body;
observer.observe(targetNode, observerConfig);